import React from "react";
import LeftSidebarMenu from "../../../shared/Layout/LeftSidebarMenu";

function LeftNavigation({ toggleActive }) {
  return (
    <LeftSidebarMenu
      menuSections={[
        {
          title: "Сторінки",
          items: [
            {
              label: "Дашборд",
              path: "/operator/dashboard",
              icon: "dashboard",
              resource: "operator.dashboard",
            },
            {
              label: "Скрипти",
              path: "/operator/scripts/",
              icon: "contact_page",
              resource: "operator.scripts",
            },
            {
              label: "LMS / Навчання",
              path: "/operator/lms/",
              icon: "auto_stories",
              resource: "operator.lms",
            },
            {
              label: "Правила роботи",
              path: "/operator/rules/",
              icon: "group_work",
              resource: "operator.rules",
            },
            {
              label: "Графік роботи",
              path: "/operator/work-schedule",
              icon: "calendar_month",
              resource: "operator.work_schedule",
            },
          ],
        },
      ]}
      toggleActive={toggleActive}
    />
  );
}

export default LeftNavigation;
